import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ProductDescription from './ProductDescription';
import { formatPrice } from '../utils/format';

import { getCategoryName } from '../constants/categories';
import { useToast } from '../context/ToastContext';

function ProductCard({ product, addToCart, badge, rating, reviewCount }) {
  const { showToast } = useToast();
  const [imageError, setImageError] = useState(false);
  
  // 이미지 로드 실패 시 대체 이미지 또는 placeholder 표시
  const handleImageError = () => {
    setImageError(true);
  };

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (addToCart) {
      addToCart(product, 1, []); // 기본 수량 1, 옵션 없음
      showToast('장바구니에 상품이 담겼습니다.', 'success');
    } else {
      showToast('장바구니 기능 오류입니다.', 'error');
    }
  };

  /* New Modern Product Card based on products.html design */
  return (
    <div className="group flex flex-col bg-white dark:bg-[#162a1c] rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 dark:border-gray-800">
      <Link to={`/products/${product.id}`} className="block relative aspect-[3/4] overflow-hidden">
        {/* Badge - 실데이터만 (badge prop 또는 isBest). 임의 라벨 금지 */}
        {(badge || product.isBest) && (
          <div
            className="absolute top-3 left-3 z-10 bg-secondary text-secondary-contrast text-[10px] font-bold px-2 py-1 rounded"
            style={{ backgroundColor: 'var(--secondary-color)' }}
          >
            {badge || 'BEST'}
          </div>
        )}
        
        {!imageError && product.imageUrl ? (
          <img 
            src={product.imageUrl} 
            alt={product.name}
            onError={handleImageError}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
          />
        ) : (
          <div className="h-full w-full bg-gray-100 dark:bg-gray-800 flex flex-col items-center justify-center text-gray-400">
            <span className="material-symbols-outlined text-4xl mb-2">local_florist</span>
            <span className="text-xs">이미지 준비중</span>
          </div>
        )}
        
        {/* Overlay effect */}
        <div className="absolute inset-0 bg-black/5 opacity-0 group-hover:opacity-100 transition-opacity"></div>
        
        {/* Cart Button (Visual only for now) */}
        <button 
          onClick={handleAddToCart}
          className="absolute bottom-4 right-4 h-10 w-10 bg-white/95 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-4 group-hover:translate-y-0 transition-all shadow-lg text-[#0d1b12]"
        >
          <span className="material-symbols-outlined">shopping_cart</span>
        </button>
      </Link>

      <div className="p-4">
        <Link to={`/products/${product.id}`}>
          <h4 className="font-bold text-sm text-[#0d1b12] dark:text-white line-clamp-2 mb-2 group-hover:text-primary-strong transition-colors">
            {product.name}
          </h4>
        </Link>
        
        <div className="flex items-baseline gap-2 mb-2">
          <span className="text-lg font-black text-[#0d1b12] dark:text-white">
            {formatPrice(product.price)}
          </span>
        </div>

        {/* 리뷰 평점 - 실데이터 있을 때만 (rating prop) */}
        {rating > 0 && (
          <div className="flex items-center gap-1 text-[11px] text-gray-500 dark:text-gray-400">
            <span className="material-symbols-outlined text-sm" style={{ color: '#f59e0b' }}>star</span>
            {rating.toFixed(1)}{reviewCount ? ` · 리뷰 ${reviewCount}` : ''}
          </div>
        )}
        
        {/* Review/Rating Placeholder - Using heuristics or random for demo premium feel if real data missing */}
        {/* Review/Rating removed as per request */}
      </div>
    </div>
  );
}

export default ProductCard;

